import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Alert,
  CircularProgress,
  Grid,
  Typography,
} from '@mui/material';
import { submitForm } from '../../services/formService';
import { LANDING_COLORS } from '../../content/landingContent';

const FIELDS = [
  { name: 'name', label: 'Ad, Soyad', placeholder: 'Ad, Soyad', required: true, type: 'text' },
  { name: 'email', label: 'E-Posta Adresiniz', placeholder: 'E-Posta', required: true, type: 'email' },
  { name: 'sector', label: 'Şirketinizin Sektörü', placeholder: 'Sektör', required: false, type: 'text' },
  { name: 'phone', label: 'Cep Telefon Numarası', placeholder: '555 555 5555', required: false, type: 'tel' },
];

const inputSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '6px',
    fontFamily: 'Cabin, sans-serif',
    fontSize: 14,
    bgcolor: '#fff',
    '& fieldset': { borderColor: '#e2e2e2' },
    '&:hover fieldset': { borderColor: LANDING_COLORS.formBorder },
    '&.Mui-focused fieldset': { borderColor: LANDING_COLORS.purpleBtn },
  },
  '& .MuiOutlinedInput-input::placeholder': {
    color: '#b5b5b5',
    opacity: 1,
  },
};

const FieldLabel = ({ children }) => (
  <Typography
    sx={{
      fontFamily: 'Cabin, sans-serif',
      fontSize: 13,
      color: LANDING_COLORS.textGray,
      mb: 0.5,
    }}
  >
    {children}
  </Typography>
);

const QuoteForm = () => {
  const [form, setForm] = useState({ name: '', email: '', sector: '', phone: '' });
  const [status, setStatus] = useState({ loading: false, error: '', success: false });

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ loading: true, error: '', success: false });

    try {
      await submitForm({
        type: 'demo_request',
        name: form.name,
        email: form.email,
        company: form.sector,
        phone: form.phone,
        message: `Teklif talebi — Sektör: ${form.sector || '-'}`,
        source: 'landing_hero',
      });
      setStatus({ loading: false, error: '', success: true });
      setForm({ name: '', email: '', sector: '', phone: '' });
    } catch (err) {
      setStatus({
        loading: false,
        error: err.response?.data?.error || 'Gönderim başarısız. Lütfen tekrar deneyin.',
        success: false,
      });
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} noValidate>
      <Grid container spacing={1.5}>
        {FIELDS.map((field) => (
          <Grid item xs={6} key={field.name}>
            <FieldLabel>{field.label}</FieldLabel>
            <TextField
              fullWidth
              required={field.required}
              name={field.name}
              type={field.type}
              placeholder={field.placeholder}
              value={form[field.name]}
              onChange={handleChange}
              size="small"
              sx={inputSx}
            />
          </Grid>
        ))}
      </Grid>

      {status.error && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {status.error}
        </Alert>
      )}
      {status.success && (
        <Alert severity="success" sx={{ mt: 2 }}>
          Talebiniz alındı. En kısa sürede size dönüş yapacağız.
        </Alert>
      )}

      <Button
        type="submit"
        fullWidth
        disabled={status.loading}
        sx={{
          mt: 2.5,
          py: 1.4,
          borderRadius: { xs: '50px', md: '6px' },
          bgcolor: LANDING_COLORS.purpleBtn,
          color: '#fff',
          fontFamily: 'Cabin, sans-serif',
          fontWeight: 700,
          fontSize: { xs: 15, md: 16 },
          textTransform: 'none',
          '&:hover': { bgcolor: LANDING_COLORS.purpleDark },
        }}
      >
        {status.loading ? <CircularProgress size={22} color="inherit" /> : 'Teklif Alın'}
      </Button>
    </Box>
  );
};

export default QuoteForm;
